<template>
  <div id="app">
    <router-view />
    <!--:key="$route.fullPath"-->
  </div>
</template>

<script>
import config from "@/framework/config";
global.config = config;
if (global.config.pessoa == null) global.config.pessoa = "pessoa";
if (global.config.perfil == null) global.config.perfil = "perfil";
if (global.config.permissao == null) global.config.permissao = "permissao";
if (global.config.admin_config == null)
  global.config.admin_config = "admin_config";

import ReqClass from "@/framework/reqclass";
global.reqClass = new ReqClass();

try{
  var bus = require("@/admin/elements/inc/bus").default;
}catch(err){
  var bus = require("@/framework/admin/elements/inc/bus").default;
}

global.bus = bus;


try{
  global.Api = require("@/services/api").default;
}catch(err){
  global.Api = require("@/framework/services/api").default;
}

  
export default {
  name: "App",
  mounted() {
    global.langinuse = this.$store.state.lang;
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style lang="scss">
/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
